import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";
import { AppDispatch } from "../../store/store";

interface SingleMedicalPaOrderState {
  singleMedicalPaOrder?: MedicalPaOrder;
  isLoading?: boolean;
  error?: string;
  unsubscribe?: () => void;
}

const initialState: SingleMedicalPaOrderState = {
  singleMedicalPaOrder: undefined,
  isLoading: false,
  error: undefined,
  unsubscribe: undefined,
};

const singleMedicalPaOrderSlice = createSlice({
  name: "singleMedicalPaOrder",
  initialState,
  reducers: {
    setSingleMedicalPaOrder: (state, action) => {
      state.singleMedicalPaOrder = action.payload;
      state.isLoading = false;
      state.error = undefined;
    },
    setUnsubscribe: (state, action) => {
      state.unsubscribe = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
      state.error = undefined;
      state.singleMedicalPaOrder = undefined;
      state.unsubscribe = undefined;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.singleMedicalPaOrder = undefined;
    },
    resetSingleMedicalPaOrder: (state) => {
      state.singleMedicalPaOrder = undefined;
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  setSingleMedicalPaOrder,
  setIsLoading,
  setError,
  resetSingleMedicalPaOrder,
  setUnsubscribe,
} = singleMedicalPaOrderSlice.actions;

export const getMedicalPaOrderDetailsFor =
  (orderId: string) => async (dispatch: AppDispatch, getState) => {
    const { singleMedicalPaOrder } = getState();
    if (singleMedicalPaOrder.isLoading) return;

    dispatch(setIsLoading(true));
    const unsubscribe = FirestoreService.listenToDocument<MedicalPaOrder>(
      FirestoreCollectionReference.medicalPaOrders(),
      orderId,
      (singleOrder) => {
        if (singleOrder) {
          dispatch(setSingleMedicalPaOrder(singleOrder));
        }
        dispatch(setUnsubscribe(unsubscribe));
      },
      (error) => {
        dispatch(setError(error.message));
      },
    );

    return unsubscribe;
  };

export default singleMedicalPaOrderSlice.reducer;
